import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Hero.css';
import glossyFig from '../../assets/logo.webp';
import circuitFig from '../../assets/images/hero_fig.webp';

const floatingPixels = [
  { left: '8%', top: '14%', size: '10px', delay: '0s' },
  { left: '14%', top: '68%', size: '18px', delay: '0.6s' },
  { left: '46%', top: '16%', size: '12px', delay: '0.2s' },
  { left: '58%', top: '24%', size: '8px', delay: '1s' },
  { left: '62%', top: '64%', size: '16px', delay: '0.4s' },
  { left: '74%', top: '12%', size: '14px', delay: '0.8s' },
  { left: '82%', top: '32%', size: '9px', delay: '1.2s' },
  { left: '88%', top: '54%', size: '20px', delay: '0.1s' }
];

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-backdrop" aria-hidden="true">
        {floatingPixels.map((pixel) => (
          <span
            key={`${pixel.left}-${pixel.top}`}
            className="hero-pixel"
            style={{
              '--pixel-left': pixel.left,
              '--pixel-top': pixel.top,
              '--pixel-size': pixel.size,
              '--pixel-delay': pixel.delay
            }}
          />
        ))}
      </div>

      <div className="container hero-container">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="hero-badge-row hero-badge-row--desktop">
            <div className="hero-badge">Enterprise Web Solutions | AI Automation</div>
          </div>
          <h1>
            Powering Businesses
            <span className="hero-heading-line">
              with <em>Digital</em>
            </span>
            <span className="hero-heading-accent">Excellence</span>
          </h1>
          <p className="hero-description">
            We build high-performance digital solutions that drive growth, improve customer
            experiences, and future-proof the way your business operates.
          </p>

          <div className="hero-buttons">
            <a href="#projects" className="btn primary-btn">Our Work</a>
            <Link to="/contact" className="btn secondary-btn">Contact Us</Link>
          </div>
        </motion.div>

        <motion.div
          className="hero-scene"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          <div className="hero-badge-row hero-badge-row--scene">
            <div className="hero-badge">Enterprise Web Solutions | AI Automation</div>
          </div>
          <div className="hero-visual">
            <div className="hero-visual-stage">
              <div className="hero-visual-glow" aria-hidden="true" />
              <img src={glossyFig} alt="Digital Fig brand mark" className="hero-fig hero-fig--main" />
              <img src={circuitFig} alt="Digital Fig circuit fig illustration" className="hero-fig hero-fig--accent" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
